export enum EStatusUploadFile {
  UPLOAD = 'UPLOAD',
  UPLOAD_LOADING = 'UPLOAD_LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  DRAG_REJECT = 'DRAG_REJECT',
  LOADING = 'LOADING',
}
